module.exports = __webpack_public_path__ + "img/activity10.656eba0a.png";